<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ExtratoAssociadoModule',
  }
</script>
